var _circle, _circle2, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesFive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "url(#paint0_linear_1486_2099)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 23,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5455 32.5556V25.4444C35.5455 24.9556 35.1568 24.5556 34.6818 24.5556H24.3182C23.8432 24.5556 23.4545 24.9556 23.4545 25.4444V26.0044C26.8745 27.1422 29.5777 29.9244 30.6832 33.4444H34.6818C35.1568 33.4444 35.5455 33.0444 35.5455 32.5556ZM37.2727 21H21.7273C20.7773 21 20 21.8 20 22.7778V24.5556C20 25.0444 20.3886 25.4444 20.8636 25.4444C21.3386 25.4444 21.7273 25.0444 21.7273 24.5556V23.6667C21.7273 23.1778 22.1159 22.7778 22.5909 22.7778H36.4091C36.8841 22.7778 37.2727 23.1778 37.2727 23.6667V34.3333C37.2727 34.8222 36.8841 35.2222 36.4091 35.2222H32.0909C31.6159 35.2222 31.2273 35.6222 31.2273 36.1111C31.2273 36.6 31.6159 37 32.0909 37H37.2727C38.2227 37 39 36.2 39 35.2222V22.7778C39 21.8 38.2227 21 37.2727 21ZM20 34.3333V37H22.5909C22.5909 36.4489 22.4268 35.9333 22.1505 35.5067C21.6841 34.7956 20.8982 34.3333 20 34.3333ZM20.9845 30.8578C20.4664 30.7689 20 31.2044 20 31.7467C20 32.1822 20.3109 32.5467 20.7341 32.6178C22.5305 32.9378 23.9468 34.3956 24.2577 36.2444C24.3268 36.68 24.6809 37 25.1041 37C25.6309 37 26.0455 36.52 25.9677 35.9867C25.5532 33.3556 23.5323 31.2844 20.9845 30.8578ZM20.95 27.2667C20.4405 27.2222 20 27.6311 20 28.1556C20 28.6089 20.3282 28.9911 20.76 29.0356C24.4477 29.4 27.3841 32.4222 27.7382 36.2178C27.7814 36.6622 28.1527 36.9911 28.5932 36.9911C29.1114 36.9911 29.5086 36.5289 29.4568 36.0044C28.9991 31.3911 25.4323 27.7289 20.95 27.2667Z",
    fill: "url(#paint1_linear_1486_2099)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1486_2099",
    x1: 29,
    y1: 118.484,
    x2: 29,
    y2: -14.9677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1486_2099",
    x1: 29.5,
    y1: 53.6852,
    x2: 29.5,
    y2: 16.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF9C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.536458,
    stopColor: "#9D3CCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1737E5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesFive);
export default __webpack_public_path__ + "static/media/featuresFive.ed987e798107fe04f4da8f9d481b3fad.svg";
export { ForwardRef as ReactComponent };